<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Users</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Admin User
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <div class="row">
          <div class="col">
            <v-text-field
              id="firstName"
              v-model="selectedObj.firstName"
              label="First Name*"
              required
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="lastName"
              v-model="selectedObj.lastName"
              label="Last Name*"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              id="email"
              v-model="selectedObj.email"
              label="Email*"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="phone"
              v-model="selectedObj.phone"
              label="Phone"
            ></v-text-field>
          </div>
        </div>
        <div class="row" v-show="!isEditPassword">
          <div class="col">
            <v-text-field
              id="passwordHint"
              v-model="selectedObj.passwordhint"
              label="Password Hint*"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="password"
              v-model="selectedObj.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              name="input-10-1"
              label="Password*"
              hint="At least 6 characters"
              counter
              @click:append="show1 = !show1"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col">
            <v-checkbox
              id="organizationUser"
              v-model="selectedObj.isOrganizationUser"
              label="Is Organization User"
              @change="isOrganizationUserChanged"
            ></v-checkbox>
          </div> -->
          <div class="col">
            <div class="Active d-none">
              <v-container class="px-0" fluid>
                <v-checkbox
                  id="IsActive"
                  v-model="selectedObj.active"
                  :label="`Active`"
                ></v-checkbox>
              </v-container>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col">
            <v-select
              id="userRole"
              v-model="selectedObj.userRole"
              :items="UserTypes"
              label="User Type*"
              item-text="roleName"
              item-value="id"
              return-object
            ></v-select>
          </div> -->
          <div class="col">
            <v-select
              v-model="selectedObj.organization"
              id="organization1"
              :items="Organizatios"
              label="Organization*"
              item-text="Name"
              item-value="id"
              return-object
              v-show="selectedObj.isOrganizationUser"
              :readonly="!selectedObj.id == 0"
            ></v-select>
          </div>
        </div>

        <div hidden>
          <div class="row">
            <div class="col">
              <v-select
                id="Gender"
                v-model="selectedObj.gender"
                :items="Genders"
                label="Gender"
                item-text="name"
                item-value="code"
              ></v-select>
            </div>
            <div class="col">
              <v-menu
                id="transaction"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    label="Birthday"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    id="computedDateFormatted"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="address1"
                v-model="selectedObj.address1"
                label="Address 1"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="address2"
                v-model="selectedObj.address2"
                label="Address 2"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="city"
                v-model="selectedObj.city"
                label="City"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="state"
                v-model="selectedObj.state"
                label="State"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="zip"
                v-model="selectedObj.zip"
                label="Zip"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="country"
                v-model="selectedObj.country"
                label="Country"
              ></v-text-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="float-right">
              <v-btn @click="onCancel()"> Cancel </v-btn>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="btnPassword"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    @click="onOpenSetPassword()"
                    v-show="isEditPassword"
                  >
                    Set Password
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Password</span>
                  </v-card-title>
                  <v-card-text>
                    <v-divider></v-divider>
                    <Notification :notify="notifyPassword" />
                    <v-row>
                      <v-col>
                        <v-text-field
                          id="passwordHint"
                          v-model="selectedObj.passwordhint"
                          label="Password Hint*"
                          required
                          counter
                        >
                        </v-text-field
                      ></v-col>
                      <v-col>
                        <v-text-field
                          id="password"
                          v-model="selectedObj.password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          name="input-10-1"
                          label="Password*"
                          hint="At least 6 characters"
                          counter
                          :rules="passwordRules"
                          @click:append="show1 = !show1"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      id="btnClose"
                      color="blue darken-1 mr-2"
                      text
                      @click="dialog = false"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="onSavePassword()"
                      id="btnSave"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-btn
                id="btnSave"
                class="mr-4"
                color="primary"
                @click="onSave()"
                :loading="loading"
                :disabled="loading"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                  <th class="text-left">Organization</th>
                  <!-- <th class="text-left">Type</th> -->
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>
                    {{
                      item.organization == null ? "" : item.organization.Name
                    }}
                  </td>
                  <!-- <td>{{ item.userRole.roleName }}</td> -->
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>

      <div class="row" v-show="isEdit && userId != 0">
        <div class="col mt-2">
          <v-divider></v-divider>
          <UserDevice :userId="userId" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import lodash from "lodash";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import UserDevice from "@/components/UserDevice";
import * as api from "@/api";

export default {
  name: "User",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    UserDevice,
  },
  created() {
    this.vars = {};
    this.getUserRoles(false);
    this.getOrganizatios();
    this.getIndividuals();
    this.getUsersByPagin();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    organizationName(organization) {
      return organization ? organization.Name : "";
    },
  },
  methods: {
    created() {},
    onNew() {
      this.isEdit = true;
      this.isEditPassword = false;
      this.selectedObj.id = 0;
      this.selectedObj.userRoleId = 0;
      this.selectedObj.countryId = 0;
      this.selectedObj.firstName = "";
      this.selectedObj.lastName = "";
      this.selectedObj.email = "";
      this.selectedObj.gender = "";
      this.selectedObj.address1 = "";
      this.selectedObj.address2 = "";
      this.selectedObj.city = "";
      this.selectedObj.state = "";
      this.selectedObj.country = "";
      this.selectedObj.zip = "";
      this.selectedObj.phone = "";
      this.selectedObj.password = "";
      this.selectedObj.passwordhint = "";
      this.selectedObj.active = false;
      this.selectedObj.userRole = {
        id: 1,
        isOrganization: false,
        roleKey: "HubAdmin",
        roleName: "Hub Admin",
      };
      this.selectedObj.isOrganizationUser = false;
      this.notify.type = 0;
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getUsersByPagin();
      //this.listFilted = this.resultQuery();
    },
    /*
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every(
              (v) =>
                item.email.toLowerCase().includes(v) ||
                item.firstName.toLowerCase().includes(v) ||
                item.lastName.toLowerCase().includes(v)
            );
        });
      } else {
        return this.list;
      }
    },*/
    onSave() {
      //if (this.selectedObj.user_type_id == "Admin")
      //  this.selectedObj.user_type_id = 1;
      //else this.selectedObj.user_type_id = 2;
      let that = this;
      if (!this.validateFrom()) {
        let jsonStringValues = JSON.stringify(this.selectedObj);
        that.overlay = true;

        if (this.selectedObj.id != 0) {
          delete this.selectedObj["password"];
          delete this.selectedObj["passwordhint"];
          delete this.selectedObj["LCPhashedPassword"];
          console.log("password removed");
        }
        console.log(this.selectedObj);

        this.loading = true;
        new Promise((resolve, reject) => {
          api
            .update("user", this.selectedObj)
            .then((response) => {
              resolve(response);
              console.log("a " + response);

              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message =
                  this.selectedObj.id === -1
                    ? "Record successfully saved."
                    : "Record successfully updated.";
                this.loading = false;
                this.isEdit = false;
                this.navFirstPage();
                this.getUsersByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else if (response.status === 409) {
                this.notify.type = 4;
                this.notify.errors.push(response.message);
                this.loading = false;
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data. 1");
                this.loading = false;
              }
              that.overlay = false;
            })
            .catch((error) => {
              that.overlay = false;
              reject(error);
              console.log(error);
              console.log(error.message);

              if (error.message == "Request failed with status code 409") {
                this.notify.type = 4;
                this.notify.errors.push("Email address already exist.");
                this.loading = false;
              } else {
                this.notify.type = 4;
                this.notify.errors.push(
                  "Failed to save data. " + error.message
                );
                this.loading = false;
              }
            });
        });
      }
    },
    onSavePassword() {
      this.notifyPassword.errors = [];
      //this.notifyPassword.errors.splice(0, this.notify.errors.length);
      this.notifyPassword.type = 4;

      if (this.selectedObj.passwordhint === "") {
        this.notifyPassword.errors.push("Password hint required.");
        return true;
      }
      if (this.selectedObj.password === "") {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }
      if (
        this.selectedObj.password != null &&
        this.selectedObj.password.length < 6
      ) {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }

      var obj = {
        id: this.selectedObj.id,
        password: this.selectedObj.password,
        passwordhint: this.selectedObj.passwordhint,
      };
      new Promise((resolve, reject) => {
        api
          .update("user/set-password", obj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.dialog = false;
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Password successfully saved."
                  : "Password successfully updated.";
              this.getUsersByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });

      this.dialog = false;
    },
    onOpenSetPassword() {
      this.notifyPassword.errors = [];
    },
    onEdit(obj) {
      this.isEdit = true;
      this.isEditPassword = true;
      obj.password = "";
      this.selectedObj = Object.assign({}, obj);
      this.userId = this.selectedObj.id;
      this.getUserRoles(this.selectedObj.isOrganizationUser);
    },
    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getUsersByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
    },
    validateFrom() {
      console.log(this.selectedObj.userRole);

      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.errors = [];
      this.notify.type = 4;

      if (this.selectedObj.firstName == "") {
        this.notify.errors.push("First name required.");
        return true;
      }
      if (this.selectedObj.lastName == "") {
        this.notify.errors.push("Last name required.");
        return true;
      }
      if (this.selectedObj.email == "") {
        this.notify.errors.push("Email required.");
        return true;
      } else {
        var nameRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/i;
        if (!nameRegex.test(this.selectedObj.email)) {
          this.notify.errors.push("Invalid Email Address.");
          return true;
        }
      }
      if (this.selectedObj.passwordhint === "" && !this.isEditPassword) {
        this.notify.errors.push("Password hint required.");
        return true;
      }
      if (this.selectedObj.password === "" && !this.isEditPassword) {
        this.notify.errors.push("Password required.");
        return true;
      }
      if (
        this.selectedObj.password != null &&
        this.selectedObj.password.length < 6 &&
        !this.isEditPassword
      ) {
        this.notify.errors.push(
          "The password should have a minimum of 6 characters"
        );
        return true;
      }
      if (this.selectedObj.userRole == null) {
        this.notify.errors.push("User type required.");
        return true;
      }
      if (
        this.selectedObj.isOrganizationUser &&
        this.selectedObj.organization == null
      ) {
        this.notify.errors.push("Organization required.");
        return true;
      }
      return false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    isEmailValid() {
      return this.reg.test(this.selectedObj.Email);
    },
    isOrganizationUserChanged() {
      this.getUserRoles(this.selectedObj.isOrganizationUser);
    },
    getUsers() {
      this.list = [];
      this.listFilted = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user")
          .then((response) => {
            console.log(response);
            this.list = response.data;
            this.listFilted = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getUsersByPagin();
    },
    getUsersByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      this.listFilted = [];

      new Promise((resolve, reject) => {
        api
          .getByPagin("user", this.paging)
          .then((response) => {
            let users = lodash.orderBy(response.data.data, "id", "desc");
            this.paging.count = response.data.count;
            this.list = users;
            this.listFilted = users;
            that.overlay = false;
          })
          .catch((error) => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getUserRoles(isOrganizationUserChanged) {
      this.UserTypes = [];
      new Promise((resolve, reject) => {
        api
          .getByID("user-role/organization", isOrganizationUserChanged)
          .then((response) => {
            console.log(response);
            this.UserTypes = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getOrganizatios() {
      this.Organizatios = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization")
          .then((response) => {
            console.log(response);
            this.Organizatios = [...this.Organizatios, ...response.data];
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getIndividuals() {
      new Promise((resolve, reject) => {
        api
          .getAll("organization/individuals")
          .then((response) => {
            this.Organizatios = [...this.Organizatios, ...response.data];
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    navFirstPage() {
      this.paging.page = 1;
    },
  },
  data() {
    return {
      list: [],
      listFilted: [],
      Organizatios: [],
      isEdit: false,
      isEditPassword: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      notifyPassword: {
        type: 0,
        message: "",
        errors: [],
      },
      Genders: [
        { code: "M", name: "Male" },
        { code: "F", name: "Female" },
      ],
      UserTypes: [],
      //UserTypes: [
      //  { id: 1, name: "Admin" },
      //  { id: 2, name: "User" },
      //],
      date: "", // new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      reg: '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,24}))$/',
      show1: false,
      password: "Password",
      dialog: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC: false },
      userId: 0,
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 6) ||
          "The password should have a minimum of 6 characters",
      ],
      overlay: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/User.vue